import React from 'react';
import { EmptyProps } from './Empty.typed';
import Text from '../../../Text/Text';
import * as Styled from './Empty.styled';
import { Space } from '../../../Space/Space';

const Empty = React.forwardRef<HTMLDivElement, EmptyProps>((props, ref) => {
  const { onClick, onPressEnter, text } = props;

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onPressEnter();
    }
  };

  return (
    <Styled.Wrapper
      role="button"
      tabIndex={0}
      ref={ref}
      onKeyDown={onKeyDown}
      onClick={onClick}
    >
      <Styled.Container>
        <Styled.Icon name="UploadCloudOutline" size="4xl" color="#953FFF" />
        <Text size="m" weight="bold">
          Add photos
        </Text>
        <Text size="s">or drag and drop</Text>
        <Space space={{ lg: 'M24', sm: 'S8' }} />
        <Text size="s" color="#999999" lineHeight="m">
          {text}
        </Text>
      </Styled.Container>
    </Styled.Wrapper>
  );
});

export default Empty;
